import React, { useContext } from "react";
import { Can, AbilityContext } from "../../permission/Can";
import { Actions, Subjects } from "../../permission/constants";
import JoinPremiumButton from "../Buttons/JoinPremiumButton/JoinPremiumButton";

interface PremiumWrapperButtonProps {
  component: any;
  entity: any;
  action: Actions;
  text?: string;
  size?: string;
}

const PremiumWrapperButton = ({
  size,
  component,
  entity,
  action,
  text,
}: PremiumWrapperButtonProps) => {
  const ability = useContext(AbilityContext);

  return ability.can(action, entity) ? (
    <>{component}</>
  ) : (
    <JoinPremiumButton text={text} size={size} />
  );
};

export default PremiumWrapperButton;
